import * as api from "./ApiClient";

export enum ModuleAccess {
    HierarchyExtractManage = 213
}

/** CONS-727 / IRON-533: Metadata Manager > View (distinct from Models > View). */
export const METADATA_VIEW_AUTH_FLAG = 'CONS-727-MetadataViewAuth';

export default class ModuleAuthHelper {  
    public static ModuleIdInAccess(moduleSecurityAccessList:api.Module[],id:number):boolean{
            if (moduleSecurityAccessList != null) {
                var moduleAccess = moduleSecurityAccessList.filter(m => m.id == id);
                if (moduleAccess.length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            return false;
    }

    public static HasMetadataModelManagementManage(moduleSecurityAccessList: api.Module[] | null): boolean {
        return moduleSecurityAccessList != null
            && ModuleAuthHelper.ModuleIdInAccess(moduleSecurityAccessList, api.ModuleAccess.MetadataManagementModelManagementManage);
    }

    public static HasMetadataModelManagementView(moduleSecurityAccessList: api.Module[] | null): boolean {
        return moduleSecurityAccessList != null
            && ModuleAuthHelper.ModuleIdInAccess(moduleSecurityAccessList, api.ModuleAccess.MetadataManagementModelManagementView);
    }

    public static CanAccessDimensions(moduleSecurityAccessList: api.Module[] | null, metadataViewAuthEnabled: boolean): boolean {
        if (ModuleAuthHelper.HasMetadataModelManagementManage(moduleSecurityAccessList)) {
            return true;
        }
        return metadataViewAuthEnabled && ModuleAuthHelper.HasMetadataModelManagementView(moduleSecurityAccessList);
    }

    /** Lists uses the same Metadata > View / Manage modules as Dimensions. */
    public static CanAccessLists(moduleSecurityAccessList: api.Module[] | null, metadataViewAuthEnabled: boolean): boolean {
        return ModuleAuthHelper.CanAccessDimensions(moduleSecurityAccessList, metadataViewAuthEnabled);
    }

    /** Subsets uses the same Metadata > View / Manage modules as Dimensions. */
    public static CanAccessSubsets(moduleSecurityAccessList: api.Module[] | null, metadataViewAuthEnabled: boolean): boolean {
        return ModuleAuthHelper.CanAccessDimensions(moduleSecurityAccessList, metadataViewAuthEnabled);
    }

    public static IsMetadataModelManagementViewOnly(moduleSecurityAccessList: api.Module[] | null, metadataViewAuthEnabled: boolean): boolean {
        return metadataViewAuthEnabled
            && ModuleAuthHelper.HasMetadataModelManagementView(moduleSecurityAccessList)
            && !ModuleAuthHelper.HasMetadataModelManagementManage(moduleSecurityAccessList);
    }

    public static CanAccessUserManagement(moduleSecurityAccessList: api.Module[] | null): boolean {
        if (moduleSecurityAccessList == null) {
            return false;
        }

        return ModuleAuthHelper.ModuleIdInAccess(moduleSecurityAccessList, api.ModuleAccess.SecurityUserManagementView)
            || ModuleAuthHelper.ModuleIdInAccess(moduleSecurityAccessList, api.ModuleAccess.SecurityUserManagementCreate)
            || ModuleAuthHelper.ModuleIdInAccess(moduleSecurityAccessList, api.ModuleAccess.SecurityUserManagementUpdate)
            || ModuleAuthHelper.ModuleIdInAccess(moduleSecurityAccessList, api.ModuleAccess.SecurityUserManagementDelete);
    }

    public static isFromMaintanaceModule(module: api.Module){
        return module.category && module.category.toLocaleLowerCase().includes("maintenance/consolidation");
    }

    public static checkButtonType(moduleName:string):string{
        if(moduleName.toLowerCase().includes("update")){
            return "ConsolidationUpdate";
        }
        else if(moduleName.toLowerCase().includes("view")){
            return "ConsolidationView";
        }
        else if(moduleName.toLowerCase().includes("import")){
            return "ConsolidationImport";
        }
        else if(moduleName.toLowerCase().includes("export")){
            return "ConsolidationExport";
        }
        else{
            return "";
        }
    }
}